module.exports = __webpack_public_path__ + "img/CECA_Endothelial.a3bbce46.png";